import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react';
import Box from '@ff/ui/Box';
import TextCarouselAnimation from '@ff/ui/TextCarouselAnimation';

export interface Props {
  textList?: string[];
}

const TEXT_ROTATION_TIME = 5000;
const ANIMATION_STAY_TIME = 3000;

export default function TitleCarousel(props: Props) {
  const { textList } = props;

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((currentText) => (currentText + 1) % textList.length);
    }, TEXT_ROTATION_TIME);

    return () => {
      clearInterval(interval);
    }
  }, [textList]);

  const text = textList?.[currentIndex];

  if (!text) {
    return null;
  }

  return (
    <Container>
      <TextCarouselAnimation
        // when key changes, component rerender, the animation will restart
        key={text}
        animationStayTime={ANIMATION_STAY_TIME}
        textStyle={{
          fontWeight: 300,
          fontSize: { _: '18px', md: '20px' },
          lineHeight: '24px',
          color: 'rgba(224, 223, 231, 1)',
        }}
      >
        {text}
      </TextCarouselAnimation>
    </Container>
  );
}

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});
